import React, { ReactNode, createContext, useEffect, useState } from 'react'
import { ISurvey } from './Global.types'

interface GlobalProviderProps {
	children: ReactNode
}

export const GlobalContext = createContext({})

export const GlobalProvider = ({
	children,
}: GlobalProviderProps): JSX.Element => {
	const [isGlobalLoading, setGlobalLoading] = useState<boolean>(true)
	const [hasGlobalError, setGlobalError] = useState<boolean>(false)
	const [isCampaignExpired, setCampaignExpired] = useState<boolean>(false)
	const [showPrivacySettings, setShowPrivacySettings] = useState<boolean>(false)
	const [companySurvey, setCompanySurvey] = React.useState<ISurvey>({
		id: '',
		employee: {
			isProfileCompleted: undefined,
		},
		campaign: {
			id: '',
			name: '',
			dateEnd: '',
			company: {
				fancyName: '',
				logoUrl: '',
			},
			campaignAnswerSessions: [
				{
					id: '',
					status: '',
					dateCompleted: null,
					questionnaire: {
						name: '',
						description: '',
					},
				},
			],
		},
	})

	useEffect(() => {
		if (!companySurvey?.employee?.isProfileCompleted && !showPrivacySettings) {
			setShowPrivacySettings(true)
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [companySurvey])

	return (
		<GlobalContext.Provider
			value={{
				isGlobalLoading,
				setGlobalLoading,
				isCampaignExpired,
				setCampaignExpired,
				hasGlobalError,
				setGlobalError,
				companySurvey,
				setCompanySurvey,
				showPrivacySettings,
			}}
		>
			{children}
		</GlobalContext.Provider>
	)
}
